import React from 'react'
import ReactDOM from 'react-dom'
import { infoMessageVariants } from '@web/modules/messages-management/styles'

const { tooltip, tooltipArrow } = infoMessageVariants()

interface TooltipProps {
  children: React.ReactNode
  position: { top: number; left: number }
}

export const Tooltip = ({ children, position }: TooltipProps) => {
  return ReactDOM.createPortal(
    <div
      className={tooltip()}
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        transform: 'translateY(-50%)'
      }}
    >
      <div
        className={tooltipArrow()}
        style={{
          borderWidth: '6px 0 8px 6px',
          borderColor: 'transparent transparent transparent black',
          transform: 'translateY(-50%)'
        }}
      ></div>
      {children}
    </div>,
    document.body
  )
}

export default Tooltip
